import { ApolloClient, InMemoryCache, ApolloProvider as Provider, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import React, { PropsWithChildren } from 'react';
import { client as authJsonClient } from './AuthJSONProvider';

const uri =
  process.env.NODE_ENV === 'development' ? 'http://192.168.100.13:4001/graphql' : 'https://api.rahtab.net/graphql';
export const client = new ApolloClient({
  uri,
  cache: new InMemoryCache(),
});

const authMiddleware = setContext(async (operation, { headers = {} }) => {
  const accessToken = await authJsonClient.getJwtToken();
  if (accessToken) headers.authorization = `Bearer ${accessToken}`;
  return { headers };
});

client.setLink(from([authMiddleware, client.link]));

export default function ApolloProvider({ children }: PropsWithChildren<{}>) {
  return <Provider client={client}>{children}</Provider>;
}
